import React from 'react';
import PropTypes from 'prop-types';
import FlatButton from 'material-ui/FlatButton';
import ContentClear from 'material-ui/svg-icons/content/clear';

import { connect } from 'react-redux';
import { clearCrudResourceData, saveFilter } from "actions";

class ClearFilterButton extends React.Component {
  handleClick = () => {
    this.props.dispatch(saveFilter(this.props.resource));
    this.props.dispatch((clearCrudResourceData(this.props.resource)));
  };

  render() {
    const { label = 'Search', icon } = this.props;

    return (
      <FlatButton
        primary
        label={label}
        onClick={this.handleClick}
        icon={icon}
      />
    );
  }
}

ClearFilterButton.propTypes = {
  label: PropTypes.string,
  resource: PropTypes.string,
  icon: PropTypes.element,
};

ClearFilterButton.defaultProps = {
  label: "Clear filter",
  icon: <ContentClear />,
};

export default connect()(ClearFilterButton);



// WEBPACK FOOTER //
// ./src/components/button/ClearFilterButton.js